import React, {
    useEffect, useReducer, useState
} from 'react'

export const LocaleContext = React.createContext({ locale: 'ja-JP', multiLang: [] })
